import React, { createElement as e } from "react";
import { Switch, Route } from "react-router";
import Header from "../components/Header";
import ImpersonationContext from "../components/ImpersonationContext";
import { Navbar, Nav, NavDropdown, Glyphicon } from "react-bootstrap";
import AccountNav from "../components/AccountNav";
import NavItemLink from "sc/ui/components/NavItemLink";
import MenuItemLink from "sc/ui/components/MenuItemLink";
import PageNotFound from "sc/ui/sites/oncall/pages/PageNotFound";
// Reporting
import ScheduleStatus from "../pages/partner-admin/ScheduleStatus";
import EngineersSearch from "../pages/partner-tech/EngineersSearch";
import SchedulePage from "../pages/partner-admin/SchedulePage";
// Users
import UsersPage from "../pages/partner-admin/users/List";
import AddUser from "../pages/partner-admin/users/Add";
import EditUserPage from "../pages/partner-admin/users/Edit";
// Regions
import RegionsPage from "../pages/partner-admin/regions/List.js";
import AddRegion from "../pages/partner-admin/regions/Add";
import EditRegionPage from "../pages/partner-admin/regions/Edit";
// Cities
import CitiesPage from "../pages/partner-admin/cities/List";
import AddCity from "../pages/partner-admin/cities/Add";
import EditCityPage from "../pages/partner-admin/cities/Edit";
// Engineers
import EngineersPage from "../pages/partner-admin/engineers/List.js";
import AddEngineer from "../pages/partner-admin/engineers/Add";
import EditEngineerPage from "../pages/partner-admin/engineers/Edit";
// Others
import GlobalSettingsPage from "../pages/partner-admin/GlobalSettingsPage";
import ContactPage from "../pages/ContactPage";

const Menu = () =>
  e(
    Navbar.Collapse,
    { className: "pull-right" },
    e(
      Nav,
      null,
      <NavDropdown
        eventKey="1"
        title={
          <span>
            <i className="glyphicon glyphicon-home" /> Scheduling
          </span>
        }
        id="administration-nav"
      >
        <MenuItemLink id="schedule-status-item-menu" eventKey="1.1" href="/">
          Regions
        </MenuItemLink>
        <MenuItemLink
          id="oncall-engineers-menu-item"
          eventKey="1.2"
          href="/on-call-engineers"
        >
          On-Call Engineers
        </MenuItemLink>
      </NavDropdown>,
    ),
    e(
      Nav,
      null,
      <NavDropdown
        eventKey="2"
        title={
          <span>
            <i className="glyphicon glyphicon-lock" /> Administration
          </span>
        }
        id="administration-nav"
      >
        <MenuItemLink id="regions-menu-item" eventKey="2.1" href="/regions">
          Regions
        </MenuItemLink>
        <MenuItemLink id="cities-menu-item" eventKey="2.2" href="/cities">
          Cities
        </MenuItemLink>
        <MenuItemLink id="engineers-menu-item" eventKey="2.3" href="/engineers">
          Engineers
        </MenuItemLink>
        <MenuItemLink id="users-menu-item" eventKey="2.4" href="/users">
          Users
        </MenuItemLink>
        <MenuItemLink
          id="global-settings-menu-item"
          eventKey="2.5"
          href="/global-settings"
        >
          Global Settings
        </MenuItemLink>
      </NavDropdown>,
    ),
    e(
      Nav,
      null,
      e(
        NavItemLink,
        { id: "contact-menu-item", eventKey: "3", href: "/contact" },
        e(Glyphicon, { glyph: "glyphicon glyphicon-envelope" }),
        " Contact",
      ),
    ),
    e(Nav, null, e(AccountNav)),
  );

export default () =>
  e(
    "div",
    { id: "admin-app" },
    e(Header, { MenuComponent: Menu }),
    e(ImpersonationContext),
    e(
      Switch,
      null,
      // Reporting
      e(Route, { path: "/", component: ScheduleStatus, exact: true }),
      e(Route, {
        path: "/schedule/:regionId",
        component: SchedulePage,
        exact: true,
      }),
      e(Route, {
        path: "/on-call-engineers",
        component: EngineersSearch,
        exact: true,
      }),
      // Users
      e(Route, { path: "/users", component: UsersPage, exact: true }),
      e(Route, { path: "/users/new", component: AddUser, exact: true }),
      e(Route, {
        path: "/user/edit/:id",
        component: EditUserPage,
        exact: true,
      }),
      // Regions
      e(Route, { path: "/regions", component: RegionsPage, exact: true }),
      e(Route, { path: "/regions/new", component: AddRegion, exact: true }),
      e(Route, {
        path: "/region/edit/:id",
        component: EditRegionPage,
        exact: true,
      }),
      // Cities
      e(Route, { path: "/cities", component: CitiesPage, exact: true }),
      e(Route, { path: "/cities/new", component: AddCity, exact: true }),
      e(Route, {
        path: "/city/edit/:id",
        component: EditCityPage,
        exact: true,
      }),
      // Engineers
      e(Route, { path: "/engineers", component: EngineersPage, exact: true }),
      e(Route, { path: "/engineers/new", component: AddEngineer, exact: true }),
      e(Route, {
        path: "/engineer/edit/:id",
        component: EditEngineerPage,
        exact: true,
      }),
      // Global Settings
      e(Route, {
        path: "/global-settings",
        component: GlobalSettingsPage,
        exact: true,
      }),
      // Contact
      e(Route, { path: "/contact", component: ContactPage, exact: true }),

      e(Route, { path: "*", component: PageNotFound, exact: true }),
    ),
  );



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/routes/PartnerAdmin.js